<div class="modal">
    <div class="card">
        <div class="card-body">
            <h3 class="card-title">{{ text || 'Da li ste sigurni?' }}</h3>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Ne</button>
            <button class="btn btn-success btn-question" (click)="emitTrue()">Da</button>
        </div>
    </div>
</div>
